import React, { useState } from "react";
import { texts } from "../lib/constants";

function QuizGroupsOptions({
  language,
  userData,
  options,
  setCurrentOptionsGroup,
  setUserTypeForm,
  isActiveVotingGroups,
  setIsActiveQuestionsGroups,
  setIsActiveVotingGroups,
  isMobile,
  isTablet,
  setShowMenu
}) {
  const [isActive, setisActive] = useState();

  const updateCurrentGroup = (groupNumber) => {
    setCurrentOptionsGroup(groupNumber);
    setIsActiveQuestionsGroups();
    setIsActiveVotingGroups(true);
    setisActive(groupNumber);
  };
  const NUMBER_OF_SCENARIOS = 15;

  return (
    <div>
      {options?.map((option, key) => {
        let groupQuestionsNumber = Math.floor(key / NUMBER_OF_SCENARIOS + 1);
        let questionNumber = key + 1;

        if (key % NUMBER_OF_SCENARIOS === 0 && questionNumber < 20) {
          return (
            <div
              onClick={() => {
                if (
                  userData && userData?.options ? (
                    userData?.options[
                      groupQuestionsNumber < 10
                        ? "G0" + groupQuestionsNumber
                        : "G" + groupQuestionsNumber
                    ]?.done !== true
                  ) : true
                ) {
                  updateCurrentGroup(key / NUMBER_OF_SCENARIOS + 1);
                setUserTypeForm("options");
                window.scrollTo(0, 0);
                setShowMenu(false);
                }
              }}
              className={
                groupQuestionsNumber === isActive && isActiveVotingGroups
                  ? "questions questions-selected text-body-2"
                  : "questions text-body-2"
              }
              key={key}
            >
              <div style={{marginRight: isMobile || isTablet ? "12px": 0}}>
                {texts[language].votingGroupText} {""}{" "}
              </div>
              {userData && userData?.options ? (
                userData?.options[
                  groupQuestionsNumber < 10
                    ? "G0" + groupQuestionsNumber
                    : "G" + groupQuestionsNumber
                ]?.done === true ? (
                  <div>
                    <img
                      style={{ paddingTop: "12px" }}
                      alt="check"
                      src="/assets/img/icon-success.png"
                    ></img>
                  </div>
                ) : userData?.options[
                    groupQuestionsNumber < 10
                      ? "G0" + groupQuestionsNumber
                      : "G" + groupQuestionsNumber
                  ] ? (
                  <span>
                    {
                      Object.keys(
                        userData?.options[
                          groupQuestionsNumber < 10
                            ? "G0" + groupQuestionsNumber
                            : "G" + groupQuestionsNumber
                        ]
                      ).length
                    }{" "}
                    <span> {texts[language].of} {NUMBER_OF_SCENARIOS}</span>
                  </span>
                ) : (
                  <div className="empty-div"></div>
                )
              ) : (
                <div className="empty-div"></div>
              )}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export default QuizGroupsOptions;
